import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { securityPhoneRequestsBackend } from './security-phone-requests.backend';
import { securityPhoneRequestsReducer } from './security-phone-requests.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'securityPhoneRequests',
      securityPhoneRequestsReducer,
    ),
    BackendModule.forFeature(
      'securityPhoneRequests',
      securityPhoneRequestsBackend,
    ),
  ],
})
export class DatastoreSecurityPhoneRequestsModule {}
